import SocketContext from "./SocketContext";
import {useCallback} from "react";
import * as SockJS from "sockjs-client";
import {Stomp} from "@stomp/stompjs";
import {getApiUrl} from "../API/getApiUrl";

let wsClient;
let sock;
const subscriptions = {};

function reConnect(doActions) {
    return new Promise((resolve, reject) => {
        try {
            const {socketApi, app, env} = getApiUrl();
            if (app && env) {
                let socket = new SockJS(socketApi);
                sock = socket;

                wsClient = Stomp.over(socket);

                wsClient.onConnect = () => {
                    resolve();
                    let sessionId = /\/([^\/]+)\/websocket/.exec(socket._transport.url)[1];
                    wsClient.subscribe('/queue/messages-user' + sessionId, (result) => {
                        // console.log(result.body)
                        doActions(JSON.parse(result.body))
                    })
                }

                wsClient.onStompError = (frame) => {
                    reject();
                    console.log('Stomp error', frame)
                }

                wsClient.activate()
            }
        } catch (e) {
            console.log('connection error', e)
        }
    })
}

export const SocketProvider = ({children}) => {

    const connect = useCallback((doActions) => {
        try {
            const {socketApi, app, env} = getApiUrl();
            if (app && env) {
                let socket = new SockJS(socketApi);
                sock = socket;

                wsClient = Stomp.over(socket);


                wsClient.onConnect = () => {
                    let sessionId = /\/([^\/]+)\/websocket/.exec(socket._transport.url)[1];
                    wsClient.subscribe('/queue/messages-user' + sessionId, (result) => {
                        console.log(result.body)
                        doActions(JSON.parse(result.body))
                    })
                }

                wsClient.onStompError = (frame) => {
                    console.log('Stomp error', frame)
                }
                wsClient.activate()
            }
        } catch (e) {
            console.log('connection error', e)
        }
    }, []);

    const disconnect = useCallback(() => {
        if (!wsClient) return;

        wsClient.disconnect(() => {
            console.log('ws disconnected, see you next time')
        });
    }, [wsClient])

    const subscribe = useCallback(async (webEvent, doActions, actions, context) => {
        try {
            const {id, sendToAll} = webEvent
            if (!wsClient) return;
            let path = getPath(sendToAll, id);
            if (!path) {
                reConnect(doActions).then(() => {
                    path = getPath(sendToAll, id)
                    console.log('subscribe to', path)
                    subscriptions[path] = wsClient.subscribe(path, (result) => {
                        console.log('result is', result);
                        console.log('actions of web events', webEvent)
                        doActions && doActions(actions, {doc: {...JSON.parse(result.body), ...context}})
                    });
                }).catch(err => {
                    console.log('reconnect error', err)
                })
                return;
            }

            console.log('subscribe to', path)
            subscriptions[path] = wsClient.subscribe(path, (result) => {
                console.log('result is', result);
                console.log('actions of web events', webEvent)
                doActions && doActions(actions, {doc: {...JSON.parse(result.body), ...context}})
            });
        } catch (e) {
            console.log('subscribe provider error', e)
        }

    }, [wsClient, sock])

    const unSubscribe = useCallback((webEvent) => {
        const {id, sendToAll} = webEvent
        const path = getPath(sendToAll, id)

        if (!path) return;

        if (!subscriptions[path]) return;

        subscriptions[path].unsubscribe && subscriptions[path].unsubscribe();

        delete subscriptions[path];

        console.log('un subscribe from', webEvent)
    }, [])

    return (
        <SocketContext.Provider
            value={{
                connect,
                disconnect,
                subscribe,
                unSubscribe
            }}
        >
            {children}
        </SocketContext.Provider>
    )
}

function getPath(sendToAll, event) {

    try {
        //return path without session id
        if (sendToAll) {
            return `/topic/${event}`
        }

        if(!sock) return null;

        if (!sock._transport) {
            console.log('session is not defined in socket transport')
            return
        }

        //find session id in socket session
        let sessionId = /\/([^\/]+)\/websocket/.exec(sock._transport.url)[1];

        return `/queue/${event}-user${sessionId}`
    } catch (e) {
        console.log('get socket path error', e)
    }
}